<template>
	<div>
		<HomeNav v-if="userNotLoggedin == true" />
		<header class="masthead mb-auto" v-if="userNotLoggedin == false">
			<nav
				class="navbar navbar-expand-lg navbar-dark bg-no-trans"
			>
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section class="py-5 bg-grey200">
			<div class="container">
				<div class="row d-flex justify-content-center">
					<div class="col-md-7">
						<h4 class="text-center font-semibold label-text">Contact Us</h4>
						<p class="label-text">
							For answers to commonly asked questions, please visit our
							<a class="link" href="/#/mediacenter">Help Center</a>. If you need
							to get in touch, we are here for you 24 hours a day, 7 days a
							week.
						</p>
						<hr />
						<div class="row light-form">
							<div class="col-md-6">
								<div class="form-group">
									<label for="FirstName" class="label-text">Name</label>
									<input
										type="text"
										class="form-control"
										id="Full Name"
										placeholder=""
									/>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label for="LastName" class="label-text">Title</label>
									<input
										type="text"
										class="form-control"
										v-model="subject"
										id="LastName"
										placeholder=""
									/>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label for="Email" class="label-text">Email</label>
									<input
										type="email"
										class="form-control"
										v-model="email"
										@focus="removeErr"
										id="Email"
										placeholder=""
									/>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label for="PhoneNumber" class="label-text">Phone Number</label>
									<input
										type="text"
										class="form-control"
										id="PhoneNumber"
										v-model="phno"
										placeholder=""
									/>
								</div>
							</div>
							<div class="col-md-12">
								<div class="form-group">
									<label for="Message" class="label-text">Message</label>
									<textarea
										class="form-control"
										rows="7"
										v-model="msg"
									></textarea>
								</div>
							</div>
							<div class="col-md-12 text-center">
								<button class="btn btn-outline-light btn-lg" @click="contact">
									Send Message
								</button>
								<p v-if="showerr" class="text-center">{{ showresmsg }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="py-5 bg-grey200 contact-text">
			<div class="container">
				<div class="row d-flex justify-content-center">
					<div class="col-md-5">
						<h4 class="font-semibold label-text">Live Chat</h4>
						<p class="label-text">You will need an internet or mobile phone connection.</p>
						<a class="mt-2 btn btn-outline-light btn-lg" href="#">
							<img src="assets/img/chat.svg" alt="" class="mr-2" /> Start Live
							Chat
						</a>
					</div>
					<div class="col-md-5">
						<h4 class="font-semibold label-text">Call Us</h4>
						<p class="label-text">You can contact us through calls</p>
						<div class="relative d-inline">
							<a
								class="mt-2 btn btn-outline-light btn-lg"
								id="myPopover"
								data-toggle="popover"
								data-trigger="focus"
								@click="togglePopupNumbers('show')"
							>
								<i class="fa fa-phone mr-2"></i> Call Us Now
							</a>
							<div class="smpopup popover show" v-if="showPopupNumbers">
								<a class="btm link" @click="togglePopupNumbers('hide')"
									><i class="fa fa-times"></i
								></a>
								<h5>Talk to our customer care Service via these numbers:</h5>
								<p>(+234)09050000924</p>
								<p>(+234)09050000907</p>
								<p>(+234)09050000924</p>
								<p>(+234)09050000907</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="py-5 bg-grey200 contact-text text-green">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<h4 class="font-semibold">GET IN TOUCH WITH US</h4>
					</div>
					<div class="col-md-6">
						<h6 class="mt-3 font-semibold">ADDRESS</h6>
						<p>
							688c, Jacob Nwakolo Close, Off Somide Odujirin Avenue, Omole Phase
							2, Ojodu Berger, Lagos.
						</p>
						<h6 class="mt-3 font-semibold">
							ADDRESS
						</h6>
						<p>
							2 688c, Jacob Nwakolo Close, Off Somide Odujirin Avenue, Omole
							Phase 2, Ojodu Berger, Lagos.
						</p>
					</div>
					<div class="col-md-3">
						<h6 class="mt-3 font-semibold">
							ADVERTS
						</h6>
						<p>adverts@ibakatv.com</p>
						<h6 class="mt-3 font-semibold">
							PHONE NUMBER
						</h6>
						<p>+234-000-0000-000</p>
						<h6 class="mt-3 font-semibold">
							LEGAL
						</h6>
						<p>legal@ibakatv.com</p>
					</div>
					<div class="col-md-3">
						<h6 class="mt-3 font-semibold">
							CONTACT SUPPORT
						</h6>
						<p>(+234)09050000924 <br />(+234)09050000907</p>
						<h6 class="mt-3 font-semibold">
							EMAIL
						</h6>
						<p>support@ibakatv.com</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<style></style>

<script>
import HomeNav from "@/components/HomeNav.vue";
export default {
	name: "contact",
	components: {
		HomeNav,
	},
	computed: {
		userNotLoggedin() {
			if( this.$store.state.user.logedin){
				return true
			} else{
				return false
			}
		},
	},
	watch: {
		phno(newval, oldval) {
			if (newval.length > 11) {
				this.phno = oldval;
			}
		},
	},
	created() {
		   this.$store.commit("showPopup", false);
		this.$store.commit("showdefaultFooter", true);
	},
	mounted() {
		window.scroll(0, 0);
	},

	methods: {
		togglePopupNumbers(ev) {
			if (ev == "show") {
				this.showPopupNumbers = true;
			} else {
				this.showPopupNumbers = false;
			}
		},
		gotoSingin() {
			this.$router.push("/login");
		},
		removeErr() {
			this.showresmsg = false;
		},
		ValidateEmail(mail) {
			var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (mail.match(mailformat)) {
				return true;
			} else {
				// alert("You have entered an invalid email address!");
				return false;
			}
		},
		contact() {
			this.isActive = true;
			self.showerr = false;
			if (this.docontact) {
				var DataToSend = {
					phone: "",
					email: this.email,
					description: this.msg,
					title: this.subject,
				};

				self = this;
				if (this.ValidateEmail(DataToSend.email)) {
					this.$store.dispatch("contactus", DataToSend).then((res) => {
						self.showresmsg = "Your email has been sent to site admin";
						self.showerr = true;
					});
				} else {
					self.showresmsg = "Invalid Email Entred";
					self.showerr = true;
				}
			}
		},
	},

	data() {
		return {
			showPopupNumbers: false,
			isActive: false,
			docontact: true,
			userid: "",
			password: "",
			title: "",
			email: "",
			phno: "",
			subject: "",
			msg: "",
			showerr: false,
			showresmsg: "",
		};
	},
};
</script>
